export class RmLevelDropDownDto{
    levelId:number;
    levelName:string;

    
    constructor(levelId:number,levelName:string){
        this.levelId = levelId;
        this.levelName = levelName;
    }
}